import axios, { AxiosInstance } from 'axios';

import Configurazione from './Configurazione';
import sessionManager, { eVariableType } from './SessionManager';

const configurazione = Configurazione();
let chiamataContoTerzi: boolean;

// Create a global Axios instance
const instance: AxiosInstance = axios.create({
    baseURL: configurazione.apiBaseUrl,
    headers: { 'Content-Type': 'application/json' },
});

// Set a default request interceptor
instance.interceptors.request.use(
    (config: any) => {
        let token: string | null | undefined;
        token = '';
        token = chiamataContoTerzi
            ? sessionManager.get(eVariableType.Tokencliente)
            : sessionManager.get(eVariableType.Token);

        // Set your bearer token here
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['AcceptLanguage'] = localStorage.getItem('codLingua') || 'it';
        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    }
);

export function api() {
    chiamataContoTerzi = false;
    return instance;
}

export function apiClienti(): AxiosInstance {
    chiamataContoTerzi = true;
    return instance;
}

export default instance;
